import { render, staticRenderFns } from "./NextTermResumption.vue?vue&type=template&id=07064a76&"
import script from "./NextTermResumption.vue?vue&type=script&lang=js&"
export * from "./NextTermResumption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports